import { Component } from '@angular/core';
import { WHATS_NEW, WhatsNewItem } from './whats-new-entries';

interface WhatsNewMonth {
  month: Date;
  label?: string;
  highlights: WhatsNewItem[]; // items with a clip, shown first
  others: WhatsNewItem[];
}

// The month-by-month list, shared by the /whats-new page and the footer's What's New dialog.
@Component({
  selector: 'app-whats-new-list',
  templateUrl: './whats-new-list.component.html',
})
export class WhatsNewListComponent {
  months: WhatsNewMonth[] = WHATS_NEW.map(release => ({
    month: this.toDate(release.month),
    label: release.label,
    highlights: release.items.filter(item => item.videoUrl),
    others: release.items.filter(item => !item.videoUrl),
  }));

  // Local date on the 1st, so the month doesn't shift west of UTC.
  private toDate(value: string): Date {
    const [year, month] = value.split('-').map(Number);
    return new Date(year, month - 1, 1);
  }
}
